import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/product';
export function FAQ() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-40" data-mp="1mbw54wto8qi1">
      <div className="mx-auto max-w-3xl" data-id="element-41" data-mp="1hdkwuqj0yo1x">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-42" data-mp="1hecr9y0vyfqm">
          FREQUENTLY ASKED QUESTIONS
        </h2>

        <div className="mt-2 divide-y divide-navy/10 overflow-hidden rounded-md border border-navy/15 bg-white shadow-sm" data-id="element-43" data-mp="1ccdnin18hgt5">
          {faqs.map(faq => <details key={faq.q} className="group" data-id="element-44" data-mp="25473cddds09t">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-2 px-3 py-2 font-head text-[14px] font-bold uppercase tracking-wide text-navy transition-colors duration-150 hover:bg-mist/60 sm:text-base" data-id="element-45" data-mp="251b5sq5g3dlw">
                {faq.q}
                <ChevronDownIcon className="h-4 w-4 shrink-0 text-volt transition-transform duration-200 ease-soft group-open:rotate-180" aria-hidden="true" data-id="element-46" data-mp="opp41wwktgaf" />
              </summary>
              <p className="px-3 pb-2 text-[13px] font-medium leading-snug text-carbon/85" data-id="element-47" data-mp="1klvy64tlzryv">
                {faq.a}
              </p>
            </details>)}
        </div>
      </div>
    </section>;
}